<template>
  <div class="widget-wrapper">
    <!-- TAMS -->
    <data-table ref="gpnSysLoginList"
                style="height: 100%"
                class="bs bs-data-table bs-data-table-slim analysis-panel-datatable"
                :data="widgetData"
                :fields="dataTableColumns"
                :resize-mode="'overflow'"
                :virtual-scrolling="false"
    />
    <!--<data-table ref="gpnSysLoginList"-->
                <!--class="bs bs-data-table bs-data-table-slim"-->
                <!--:data="widgetData"-->
                <!--:height="dataTableHeight"-->
                <!--:fields="dataTableColumns"-->
                <!--:virtual-scrolling="isMaximumWidget ? false : true"-->
    <!--/>-->
  </div>
</template>

<script>
  // 전역 이벤트버스 모듈
  import Bus from '~/plugins/event-hub'

  import Moment from 'moment'
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'
  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'
  // 스토어 헬퍼 객체
  const {mapGetters} = createNamespacedHelpers('common/common')
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetSysLoginList',
    components: {},
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 2,
        title: 'widgetSysLoginList',
        isLock: false,
        isMove: true,
        isSync: true, // TAMS
        isResize: false,
        isRefresh: false, // TAMS
        opts: {
          isDeviceFilter: false // TAMS
        },
        widgetData: [],
        timerValue: 10000,
        timerObject: null,
        lastEndTime: '', // TAMS 미사용
        currentSelect: {},
        dataTableHeight: 226, // TAMS 미사용
        // TAMS
        isRealtime: true,
        destroyCall: false
      }
    },
    computed: {
      ...mapGetters([
        'getDeviceTime'
      ]),
      dataTableColumns () {
        return [
          {
            name: 'admin_id',
            align: 'left',
            title: this.$t('dash.widgetSysLoginList_title_admin'),
            sorting: false
          },
          {
            name: 'admin_ip',
            align: 'left',
            title: this.$t('dash.widgetSysLoginList_title_adminIp'),
            sorting: false
          },
          // TAMS 수정
          {
            name: 'auth_type',
            align: 'center',
            title: this.$t('dash.widgetSysLoginList_title_authority'),
            sorting: false,
            itemTemplate: this.itemTemplateAuthType
          },
          {
            name: 'time',
            align: 'left',
            title: this.$t('dash.widgetSysLoginList_title_loginTime'),
            sorting: false
          }
        ]
      },
      preExecTask () {
        var dataTable = this.$refs.gpnSysLoginList
        return function () {
          dataTable.destroy()
          dataTable = null
        }
      }
    },
    beforeCreate () {},
    created () {
      this.destroyCall = false // TAMS
    },
    beforeMount () {},
    mounted () {
      // TAMS
      // 최대화 팝업이 아닌 경우, 실시간 타이머 생성
      if (!this.isMaximumWidget && !this.destroyCall) {
        this.timerObject = setInterval(this.getWidgetContentsData, this.timerValue)
      }
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 비동기 콜로 인한 setInterval 타이밍 역전 현상 해결 위함 (TAMS)
      this.destroyCall = true

      // 타이머 객체가 있으면 타이머 소멸
      if (this.timerObject) {
        clearInterval(this.timerObject)
      }

      // 데이터 테이블 초기화
      this.$refs.gpnSysLoginList.destroy()

      // 모델 초기화
      this.widgetData = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      async getWidgetContentsData (init = false) {
        const contentsOptions = {
          topN: 50,
          widgetType: 'system_login_admin'
        }

        /*
          - 10초 데이터 초기화 시 (실시간 추이 데이터)
            현재 장비시간의 -30초 ~ 10초 이전 데이터 호출
        */
        // 삭제 예정
        // if (!init && this.lastEndTime !== '') {
        //   // 마지막 요청 시간을 시작 시간으로 설정 (14:05:00)
        //   const sTime = Moment(this.lastEndTime).add(1, 'seconds')
        //
        //   // 1초 더한 시간을 시작 시간으로 추가 (14:05:00)
        //   contentsOptions.sTime = sTime.format('YYYY-MM-DD HH:mm:ss')
        //
        //   // 시작시간 + 9초를 끝시간으로 추가 (14:05:00 ~ 14:05:09)
        //   contentsOptions.eTime = Moment(sTime).add(9, 'seconds').format('YYYY-MM-DD HH:mm:ss')
        // } else {
        //   // 실시간 위젯은 위젯 데이터를 30초를 뺀 시간을 기준으로 한다. (Ex. 14:05:37초일 경우 기본 계산 시간은 14:05:07초)
        //   const calcBaseTime = Moment(this.getDeviceTime).subtract(30, 'seconds')
        //
        //   // 계산된 시간에서 1초 단위를 초기화. (14:05:00)
        //   const endTime = calcBaseTime.seconds(this.floorSecondTime(calcBaseTime.seconds()))
        //
        //   // 계산된 endTime에서 10초 빼기. (14:04:50)
        //   const startTime = _.cloneDeep(endTime).subtract(10, 'seconds')
        //
        //   // endTime에서 1초 빼기 (14:04:59)
        //   contentsOptions.eTime = endTime.subtract(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')
        //
        //   // startTime 추가 (13:05:00 ~ 14:04:59로 최초 요청)
        //   contentsOptions.sTime = startTime.format('YYYY-MM-DD HH:mm:ss')
        // }

        /*
          - 10초 데이터 초기화 시 (실시간 추이 데이터)
            [현재 장비시간의 -30초 ~ 1분 이전] 데이터 호출 (TAMS 수정됨)
        */
        // 실시간 위젯은 위젯 데이터를 30초를 뺀 시간을 기준으로 한다. (Ex. 14:05:37초일 경우 기본 계산 시간은 14:05:07초)
        const calcBaseTime = Moment(this.getDeviceTime).subtract(30, 'seconds')

        // 계산된 시간에서 1초 단위를 초기화. (14:05:00)
        const endTime = calcBaseTime.seconds(this.floorSecondTime(calcBaseTime.seconds()))

        // 계산된 endTime에서 10초 빼기. (14:04:50)
        // const startTime = _.cloneDeep(endTime).subtract(10, 'seconds')
        // TAMS - 계산된 endTime에서 1분 빼기. (14:04:00)
        const startTime = _.cloneDeep(endTime).subtract(1, 'minutes')

        // endTime에서 1초 빼기 (14:04:59)
        contentsOptions.eTime = endTime.subtract(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')

        // startTime 추가 (14:04:00 ~ 14:04:59로 최초 요청)
        contentsOptions.sTime = startTime.format('YYYY-MM-DD HH:mm:ss')

        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          this.widgetData = []
        }

        // API 조회
        // const {code, eTime, result} = await this.getWidgetData(contentsOptions)
        // TAMS
        const {code, result} = await this.getWidgetData(contentsOptions)

        // this.lastEndTime = eTime // TAMS 미사용

        if (code === 'ok') {
          this.widgetData = result.result || []
        } else {
          this.widgetData = [] // TAMS
        }

        // Progress 출력 여부
        this.showProgress(false)
      },
      /*
        이름: onResizeContentsFromWidget
        설명: 리사이즈 이벤트가 발생하면, 데이터 테이블의 높이를 수정한다. (TAMS 미사용)
      */
      onResizeContentsFromWidget () {
        const newHeight = this.$el.clientHeight - 24

        if (this.dataTableHeight !== newHeight) {
          this.dataTableHeight = newHeight
        }
      },
      itemTemplateAuthType (value) {
        const $span = $('<span>')
        let text = '', className = ''

        if (value === 1) {
          text = 'Administrator'
          className = 'label label-4'
        }
        if (value === 3) {
          text = 'Super-Administrator'
          className = 'label label-0'
        }
        $span.text(text).addClass(className)

        return $span
      }
    },
    watch: {
      /*
        이름: widgetData
        설명: 원본 위젯 데이터가 변경되면 최대화 팝업 모델을 업데이트한다.
      */
      widgetData (widgetData) {
        // 최대화 위젯이 아니고, isSync를 사용하는 경우
        if (!this.isMaximumWidget && this.isSync) {
          // 데이터가 들어오면 최대화 팝업에 데이터 전달
          Bus.$emit(`${this.$options.name}_sync_maximumpopup`, { widgetData })
        }
      }
    }
  }
</script>

<style scoped>
</style>
